module.exports = __webpack_public_path__ + "static/media/star_icon.45e812f5.svg";